module.exports = "https://www.gc-pro.gnp.com.mx/1dfe49fb0cefd2e37c0121acacdfc656.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/directorio/2.png
// module id = 1023
// module chunks = 0 1